import styled from 'styled-components';

interface Props {
  text: string;
  desc?: string;
  onClose: () => void;
}

function EventAlert({ text, desc, onClose }: Props) {
  return (
    <Container
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <Inner onClick={(e) => e.stopPropagation()}>
        <Header>
          <CloseButton onClick={onClose}>
            <img src="/assets/images/close/close-black24.svg" alt="" />
          </CloseButton>
        </Header>
        <Content>
          <Text>{text}</Text>
          {desc && <Desc>{desc}</Desc>}
        </Content>
        <ConfirmButton
          onClick={() => {
            onClose();
          }}
        >
          확인
        </ConfirmButton>
      </Inner>
    </Container>
  );
}

export default EventAlert;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3000;
  padding: 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Inner = styled.div`
  display: flex;
  width: 100%;
  padding: 24px 20px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 20px;
  background: #fff;
`;

const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
`;

const CloseButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: #f2f2f2;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const Text = styled.div`
  align-self: stretch;
  color: #222;
  text-align: center;
  font-family: Paperlogy;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 53.2px */
`;

const Desc = styled.div`
  align-self: stretch;
  color: #6a6a6a;
  text-align: center;
  font-family: Paperlogy;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 28px */
`;

const ConfirmButton = styled.button`
  margin-top: 24px;
  cursor: pointer;

  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 16px;
  background: #222;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.64px;
`;
